<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="certificationData"
      :loading="loading"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    >
      <!-- @submit-add="handleSubmit" -->
      <template
        slot="header"
      >
        <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            :disabled="downloading"
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownload"
          >
            <feather-icon
              icon="DownloadIcon"
              size="18"
            />
          </b-button>
        </my-tooltip>
      </template>
      <template
        slot="menu"
        slot-scope="{row}"
      >
        <feather-icon
          icon="DownloadIcon"
          variant="success"
          style="cursor: pointer;"
          size="18"
          @click="rowDownload(row.item)"
        />
      </template>

    </edit-table>
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue';
import Certification from '@/api/worker/certification';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { deepClone } from '@/util/util';
import { BButton, BOverlay } from 'bootstrap-vue'

export default {
  components: {
    EditTable,
    BButton,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: '',
    },
    baseInfo: {
      type: [Array, Object],
      default: () => {},
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      certificationData: [],
      hasToStringTypes: ['select'],
      loading: false,
      downloading: false,
    }
  },
  computed: {
    option() {
      const option = {
        editBtn: this.detailType !== 'view',
        delBtn: false,
        addBtn: false,
        columns: [
          {
            label: this.i18n('certName'),
            field: 'fileName',
            class: 'table-td table-td-sm',
            formOption: {
              rules: 'required',
            },
            // disabled: true,
          },
          {
            label: this.i18n('certType'),
            field: 'certType',
            type: 'select',
            dictField: 'certTypeName',
            dictBizCode: 'worker_cert_type',
            class: 'table-td table-td-sm',
          },
          {
            label: this.i18n('expiryDate'),
            field: 'expirationDate',
            class: 'table-td table-td-sm',
            type: 'date',
            // disabled: false,
          },
          // {
          //   label: '更新时间',
          //   field: 'expirationDate',
          //   class: 'table-td table-td-sm',
          // },
          // {
          //   label: this.i18n('certFiles'),
          //   field: 'certFiles',
          //   class: 'table-td',
          //   dictField: 'attachs',
          //   type: 'upload',
          //   uploadLimit: 10,
          //   size: 'sm',
          // },
        ],
      }
      return option
    },
    form() {
      const res = []

      this.data.forEach(row => {
        const temp = row
        this.option.columns.forEach(item => {
          if (this.hasToStringTypes.indexOf(item.type) !== -1) {
            temp[item.field] = row[item.field].toString()
          }
        });
        res.push(temp)
      })
      return res
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 国际化
    // i18n(param) {
    //   return this.$t(`_staff.labelCert.${param}`)
    // },
    i18n(param) {
      return this.$t(`_worker.labelCert.${param}`)
    },
    rowDownload(item) {
      this.loading = true
      Certification.getFileUrl({ fileId: item.fileId }).then(res => {
        const a = document.createElement('a');
        const url = res.data.data
        a.href = url
        a.click();
        window.URL.revokeObjectURL(url);
        this.loading = false
      })
    },
    async handleDownload() {
      this.downloading = true
      const zip = new JSZip()
      const code = this.baseInfo.employmentCode
      const dirName = code
      zip.folder(dirName)
      const resData = []
      const cache = {}
      const promises = []
      this.certificationData.forEach(el => {
        el.attachs.forEach(async item => {
          const tempData = {
            url: item.link,
            originalName: item.originalName,
          }
          resData.push(tempData)
        })
      })

      resData.forEach(item => {
        const promise = this.getFile(item.url).then(data => {
          const fileName = item.originalName;
          zip.file(`${dirName}/${fileName}`, data, { binary: true })
          cache[fileName] = data;
        })
        promises.push(promise)
      })
      Promise.all(promises).then(() => {
        zip.generateAsync({ type: 'blob' }).then(context => {
          const blob = new Blob([context]);
          const a = document.createElement('a');
          const resUrl = window.URL.createObjectURL(blob);
          a.href = resUrl
          a.download = `${dirName}.zip`
          a.click();
          this.downloading = false
          window.URL.revokeObjectURL(resUrl);
        })
      })
    },
    // 通过url获取具体文件并将文件转为blob对象
    getFile(url) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then(res => {
            resolve(res.blob());
          });
      });
    },
    async onLoad() {
      this.loading = true
      // console.log(this.baseInfo.folderId, 'baseInfo++==')
      // fileId
      const res = await Certification.getList(1, -1, { workerId: this.currentId, folderId: this.baseInfo.folderId })
      if (!res.data.data || !res.data.data.length) {
        this.certificationData = []
      } else {
        const temp = res.data.data.map(el => ({
          ...el,
          id: el.fileId,
        }))
        this.certificationData = temp
      }
      this.loading = false
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context]);
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url
      a.download = fileName
      a.click();
      window.URL.revokeObjectURL(url);
    },
    handleSubmit(done, row) {
      const params = deepClone(row)
      if (Array.isArray(row.attachs)) {
        params.certFiles = row.attachs.map(o => o.attachId).join()
      }
      Certification.submit({ ...params, ...{ workerId: this.currentId } }).then(async res => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      })
    },
    handleUpdate(done, row = {}) {
      const params = deepClone(row)
      // if (Array.isArray(row.attachs)) {
      //   params.certFiles = row.attachs.map(o => o.attachId).join()
      // }
      if (!params.expirationDate) {
        params.expirationDate = null
      }
      delete params.id
      delete params.certTypeName
      Certification.update({ ...params, ...{ workerId: this.currentId } }).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      })
    },
    handleRowDel(done, row) {
      Certification.remove(row.id).then(async () => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
        await this.onLoad()
        done()
      }).catch(err => {
        done()
      });
    },
    refreshChange() {
      this.onLoad()
    },
  },
}
</script>
<style lang="scss">
.form-certification{
  &-top{
    text-align: right;
  }
  .table-td{
    text-align: center;
    line-height: 50px;
    &-sm{
      width: 200px;
    }
  }
}
</style>
